/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getSearchManager, getSearchState, getActiveSearchAPIObj } from "selectors/searchSelectors";
import { searchStates } from "search/SearchConstants";
import { SignalDispatcher } from "dc-preview-utils/src/Utils/SignalDispatcher";

export const getNewSearchAPIObj = stores => {
  class SearchAPI {
    constructor() {
      this._updateCb = null;
    }

    _shouldProceed() {
      if (this !== getActiveSearchAPIObj(stores) || getSearchState(stores) === searchStates.NO_ACTIVE_SEARCH)
        return false;
      return true;
    }

    getUpdateCb() {
      return this._updateCb;
    }

    onResultsUpdate(cb) {
      if (!this._shouldProceed()) return false;
      if (this._updateCb) {
        this._updateCb.reset();
      } else {
        this._updateCb = new SignalDispatcher();
      }
      this._updateCb.on("searchresultsupdate", cb);
      stores.searchStore.sendOnResultsUpdate(stores);
      return true;
    }

    next() {
      if (!this._shouldProceed()) return false;
      let searchManager = getSearchManager(stores);
      if (searchManager) {
        searchManager.onNextClicked(searchManager.getQueryString());
        return true;
      }
      return false;
    }

    previous() {
      if (!this._shouldProceed()) return false;
      let searchManager = getSearchManager(stores);
      if (searchManager) {
        searchManager.onPreviousClicked(searchManager.getQueryString());
        return true;
      }
      return false;
    }

    clear() {
      if (!this._shouldProceed()) return false;
      let searchManager = getSearchManager(stores);
      if (searchManager) {
        searchManager.clearSearch();
        stores.searchStore.setActiveSearchAPIObj(null);
        return true;
      }
      return false;
    }
  }

  return new SearchAPI();
};
